<template>
  <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" :style="{display: showflag?'block':'none'}">
      <div class="delete-content">
          <div class="right">
              <a title="关闭" href="javascript:;"><button type="button" class="dle font16" @click="cancel()"><span class="glyphicon glyphicon-remove"></span></button></a>
          </div>
          <div class="delt-cont">
              <div class="dn">
                    <span class="img left"><img src="/static/images/logo-s.png" alt="user"></span>
                    <div class="delt-bot">
                       <span class="t"> {{ message }} </span>
                       <button type="button" class="btn btn-del right30" @click="ok()">确 定</button>
                       <button type="button" class="btn btn-del right30" @click="cancel()">取 消</button>
                    </div>
              </div>
          </div>
      </div>
  </div>
  <div class="modal-backdrop fade in" :style="{display: showflag?'block':'none'}"></div>
</template>

<script>
export default {

  name: 'ConfirmView'

}
</script>



/** WEBPACK FOOTER **
 ** Confirm.vue?3a375321
 **/